import ErrorType from './ErrorType';


class ResponseHandler {
  handle(handler) {
    return function handlerInternal(response) {
      return new Promise((resolve, reject) => {
        if (response.status >= 400) {
          reject(
            (response.status === 401)
            ? {type: ErrorType.Authorization}
            : 'server error'
          )
        } else {
          try {
            resolve(handler(response));
          } catch (err) {
            reject(err);
          }
        }
      });
    }
  }
}

export default ResponseHandler;


// WEBPACK FOOTER //
// ./src/services/ResponseHandler.js